import CardInfo from './CardInfo'

const Events = () => {
  document.querySelectorAll('details').forEach(item => {
    item.addEventListener('toggle', () => {
      if (item.open) {
        document.querySelectorAll('details').forEach(otherItem => {
          if (otherItem !== item && otherItem.open) {
            otherItem.open = false;
          }
        });
      }
    });
  });

  return (
    <>
      <CardInfo
        text={
          <>
          <details>
            <summary> 
              Hogwarts 
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M18 15L12 9L6 15" stroke="#8d5f31db" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </summary>
            <p>
              Durante seu tempo em Hogwarts, quando Voldemort estava agindo deliberadamente, os alunos tiveram que passar por provações, incluindo o desaparecimento e até morte de nascidos trouxas e mestiços que resultou em um confinamento na escola, Dumbledore não imaginava que tinha trancafiado o responsável junto deles. 
              <br />
              <br />
              A autora dos crimes era Cimmeria Soleil a nova professora de advinhação, uma comensal da morte cujo as ideias se alinhavam com não acreditar que estes mereciam uma educação bruxa, ela sequestrava os alunos e os torturava até que aceitassem sair de Hogwarts, usando um feitiço para que não pudessem falar sobre o ocorrido ao mandá-los para casa, como se tivessem simplesmente fugido e a ideia originasse deles mesmos. 
              <br />
              <br/>
              Suas ações foram descobertas quando dois alunos do sexto ano foram levados na noite de uma festa, seus amigos mais determinados de descobrir o que ocorria do que nunca. Ambos conseguiram fugir enquanto ainda podiam falar sobre, a desmascarando frente a direção e posteriormente o ministério. 
              <br />
              <br/>
              A forma como Albus Dumbledore lidou com o caso, sua indiferença a cerca disso, foi punida, de forma que este deixou a direção e foi substituído por Minerva McGonnagal.
              <br />
              <br/>
              Cimmeria Soleil não pagou por seus crimes, os aurores não tendo encontrado sinal algum dela, mas continua sendo procurada.
            </p>
          </details>
          <details>
            <summary> 
              Atualmente 
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M18 15L12 9L6 15" stroke="#8d5f31db" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </summary>
            <p>
              Depois de desaparecimentos e as posteriores mortes desses desaparecidos noticiados no profeta diário, a Ordem da Fênix decidiu entrar em ação, procurando confirmar se os autores dos crimes seriam os Comensais da Morte.
              <br />
              <br/>
              Durante sua investigação, descobriram que duas das vítimas estavam trabalhando juntas numa pesquisa sobre artes das trevas, se tornando obcecadas por um assunto específico e por terem informações sobre ele, se tornaram pessoas de interesse aos seguidores de Voldemort.
              <br />
              <br/>
              Roubos de artefatos mágicos também foram notificados, não tendo relação alguma entre si.
              <br />
              <br/>
              A ordem decidiu que seu próximo passo seria, sob o uso de poção polissuco, interrogar prisioneiros em Azkaban (em paralelo com uma pesquisa em um dos livros de interesse da dupla citada anteriormente) ditos como próximos de Voldemort por seus arquivos no ministério, informação conseguida graça a um dos membros com uma posição lá dentro. Destes prisioneiros, conseguiram a informação de que os comensais almejavem tomar o ministerio, possíveis pistas dos roubos e sequestros assim como nomes de membros do grupo. Um dos motivos citados sendo um ritual antigo (Posteriormente será descoberto ser a criação de horcruxes).
              <br />
              <br/>
              Os comensais roubaram as anotações que Lily mantinha sobre suas descobertas durante a leitura dos livros citados anteriormente, quais foram pegos da sessão proibida da bibliotica de Hogwarts, as informações que anotou estando em gales. Regulus sendo quem está tentando decifrá-las.
              <ul>
                <li> Os comensais foram reponsáveis pelo sequestro e assassinato de uma jornalista do profeta diário, Misty Quigley, uma pessoas de dentro do grupo deles estando no posto agora, um dos passos para sua missão de estar no controle da população bruxa, ainda assim, a maioria ali dentro está na oposição de Voldemort. O autor do crime: Barty Crouch Jr, quem foi detido em Azkaban por uma semana, junto de Sirius quem estava no lugar errado, na hora errada, também sendo incriminado, ambos saindo da prisão pela persuasão de Narcissa. </li>
              </ul>
              Nesse meio tempo, Voldemort e seus seguidores conseguiram reunir todos os objetos necessários para que criasse suas horcruxes, como comemoração e forma de mostrar presença, os comensais durante uma festa de Halloween drograram membros da ordem, os fazendo alucinar com seus maiores medos enquanto os roubavam, por fim, invocando a marca negra no céu. Ele estava de volta.
            </p>
          </details>
          </>
        }
      />
    </>
  )
}

export default Events
